<template>
  <layout-main-inner title="溯源信息">
    <layout-card-wrap>
      <el-tabs v-model="activeTab">
        <el-tab-pane
          label="证书管理"
          name="1">
          <certificate-list />
        </el-tab-pane>
        <el-tab-pane
          label="种植环境"
          name="2">
          <plat-env-list />
        </el-tab-pane>
        <el-tab-pane
          label="生产环境"
          name="3">
          <work-env-list />
        </el-tab-pane>
      </el-tabs>
    </layout-card-wrap>
  </layout-main-inner>
</template>

<script>
import CertificateList from '../certificate/list'
import PlatEnvList from '../plat-env/list'
import WorkEnvList from '../work-env/list'
export default {
  name: 'ProductInfos',
  components: { CertificateList, PlatEnvList, WorkEnvList },
  props: {},
  data() {
    return {
      activeTab: '1'
    }
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  methods: {

  }
}
</script>
